import { render } from "./TrelloCard.vue?vue&type=template&id=ab317978&scoped=true"
import script from "./TrelloCard.vue?vue&type=script&lang=js"
export * from "./TrelloCard.vue?vue&type=script&lang=js"

import "./TrelloCard.vue?vue&type=style&index=0&id=ab317978&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab317978"]])

export default __exports__